// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "fareHeadingItem-1vyv3";
export { _1 as "__esModule", _2 as "fareHeadingItem" }
export default { "__esModule": _1, "fareHeadingItem": _2 }
